import { Form, Input, Modal, Radio, message } from 'antd';
import 'moment/locale/es';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../../common/request/authFetch';
import { SENTIMENT_ICONS } from '../Label';

export const AddLabelModal = (props: {reviewId: string, category: string, score: number, onFinish: any}) => {

	const [form] = Form.useForm();
	const { projectGroup } = useAuth();

	const sentiment = getSentiment(props.score)
	const onFormFinish = async (values: any) => {

		const data = {
			...values,
            reviewId: props.reviewId,
            category: props.category
        };
 
		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/comments/labels`, { method: 'POST', data: data })
        .then((ok: boolean) => {	
			if (ok) {
				props.onFinish();
            } else {
                message.error("Error al intentar crear la etiqueta", 3);
            }
        })
	}

	return (

		<Modal open={true} onOk={() => form.submit()} onCancel={props.onFinish} afterClose={form.resetFields}>

			<h2>Añadir etiqueta</h2>
            <br/>
			<Form layout='vertical' form={form} onFinish={onFormFinish} initialValues={{sentiment: sentiment}}>
				<Form.Item label='Categoría'>
					<Input
						value={props.category}
						disabled
						style={{
							color: 'rgba(0, 0, 0, 0.85)',
							background: '#f5f5f5',
							cursor: 'default',
						}}
					/>
				</Form.Item>
                <Form.Item					
					name='name'
					label='Etiqueta'
					rules={[{ required: true, message: 'La etiqueta es obligatoria' }]}>
					<Input/>
				</Form.Item>												
				
				<Form.Item					
					name='sentiment'
					label='Sentimiento'>
					<Radio.Group>
						<Radio style={{fontSize:'24px'}} value={'NEGATIVE'}>{SENTIMENT_ICONS['NEGATIVE']}</Radio>
						<Radio style={{fontSize:'24px'}} value={'NEUTRAL'}>{SENTIMENT_ICONS['NEUTRAL']}</Radio>
						<Radio style={{fontSize:'24px'}} value={'POSITIVE'}>{SENTIMENT_ICONS['POSITIVE']}</Radio>
					</Radio.Group>
				</Form.Item>												
			</Form>			
		</Modal>
	)
}

const getSentiment = (score: number) => {
	switch (score) {
	  case 1:
	  case 2:
		return 'NEGATIVE';
	  case 3:
		return 'NEUTRAL';
	  case 4:
	  case 5:
		return 'POSITIVE';
	  default:
		return 'NEUTRAL'; 
	}
  };